import {enforceIntoRange, limitDecimalPlaces} from '@gl/lit/utils/numbers.js';
import {
  isCanvasConnectionType,
  isCanvasNodeType,
} from '@gl/lit/types/canvas.js';

/**
 * Sorts a node list so that connections & nodes are grouped in order.
 */
export function sortCanvasElements(nodes: Node[]) {
  return nodes.sort((a, b) => {
    if (isCanvasConnectionType(a) && isCanvasNodeType(b)) {
      return 1;
    }

    if (isCanvasNodeType(a) && isCanvasConnectionType(b)) {
      return -1;
    }

    return 0;
  });
}

/**
 * Calculate the new scale value
 * and enforce it to be 0 or bigger, with the related precision
 */
export function calculateScale(current: number, delta: number): number {
  const value = limitDecimalPlaces(current + delta, 3);
  return enforceIntoRange(0, value, 10);
}
